/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentPrizeBreakdown } from './TournamentPrizeBreakdown';
import {
    TournamentPrizeBreakdownFromJSON,
    TournamentPrizeBreakdownFromJSONTyped,
    TournamentPrizeBreakdownToJSON,
    TournamentPrizeBreakdownToJSONTyped,
} from './TournamentPrizeBreakdown';
import type { TournamentPrizeTier } from './TournamentPrizeTier';
import {
    TournamentPrizeTierFromJSON,
    TournamentPrizeTierFromJSONTyped,
    TournamentPrizeTierToJSON,
    TournamentPrizeTierToJSONTyped,
} from './TournamentPrizeTier';
import type { TournamentPrizeCalculation } from './TournamentPrizeCalculation';
import {
    TournamentPrizeCalculationFromJSON,
    TournamentPrizeCalculationFromJSONTyped,
    TournamentPrizeCalculationToJSON,
    TournamentPrizeCalculationToJSONTyped,
} from './TournamentPrizeCalculation';

/**
 * 
 * @export
 * @interface TournamentPrizePool
 */
export interface TournamentPrizePool {
    /**
     * Total prize pool value
     * @type {number}
     * @memberof TournamentPrizePool
     */
    total?: number;
    /**
     * 
     * @type {TournamentPrizeCalculation}
     * @memberof TournamentPrizePool
     */
    type?: TournamentPrizeCalculation;
    /**
     * Devour-funded base in USD dollars committed to the winner pool, on top of any entry fees collected. Requires a payoutTableId. Converted to Fuel at distribution time using the Fuel price at payout, so a committed $50 pays $50 of Fuel whenever it settles.
     * @type {number}
     * @memberof TournamentPrizePool
     */
    guaranteedPoolUsd?: number;
    /**
     * Rank rewards — RewardConfig items granted by finishing position. Independent of the payout table; configuring both gives you both.
     * @type {Array<TournamentPrizeTier>}
     * @memberof TournamentPrizePool
     */
    tiers?: Array<TournamentPrizeTier>;
    /**
     * 
     * @type {Array<TournamentPrizeBreakdown>}
     * @memberof TournamentPrizePool
     */
    breakdown?: Array<TournamentPrizeBreakdown>;
}



/**
 * Check if a given object implements the TournamentPrizePool interface.
 */
export function instanceOfTournamentPrizePool(value: object): value is TournamentPrizePool {
    return true;
}

export function TournamentPrizePoolFromJSON(json: any): TournamentPrizePool {
    return TournamentPrizePoolFromJSONTyped(json, false);
}

export function TournamentPrizePoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPrizePool {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'type': json['type'] == null ? undefined : TournamentPrizeCalculationFromJSON(json['type']),
        'guaranteedPoolUsd': json['guaranteedPoolUsd'] == null ? undefined : json['guaranteedPoolUsd'],
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(TournamentPrizeTierFromJSON)),
        'breakdown': json['breakdown'] == null ? undefined : ((json['breakdown'] as Array<any>).map(TournamentPrizeBreakdownFromJSON)),
    };
}

export function TournamentPrizePoolToJSON(json: any): TournamentPrizePool {
    return TournamentPrizePoolToJSONTyped(json, false);
}

export function TournamentPrizePoolToJSONTyped(value?: TournamentPrizePool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'type': TournamentPrizeCalculationToJSON(value['type']),
        'guaranteedPoolUsd': value['guaranteedPoolUsd'],
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(TournamentPrizeTierToJSON)),
        'breakdown': value['breakdown'] == null ? undefined : ((value['breakdown'] as Array<any>).map(TournamentPrizeBreakdownToJSON)),
    };
}

